<!--Implement the Target Section-->
<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-12 text-left">
                  <h5 class=" card-category">Strategy Builder</h5>
                  <h2 class=" card-title"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement the target strategy</h2>
                </div>
              </div>
            </div>
            <div class=" card-body">

              <!-- Adjusted Strategy -->
              <div class="col-12 mt-3">
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAnalyticsTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Exposure"></mat-tab>
                  <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Absolute"></mat-tab>
                  <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Relative"></mat-tab>
                  <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Rating"></mat-tab>
                  <mat-tab *ngIf="hasOriginal || hasDefault || hasCustomized" label="Robustness"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Exposure table -->
                <table *ngIf="selectedAnalyticsTab=='exposure' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="35%"></th>
                    <th *ngIf="hasOriginal">Original Portfolio</th>
                    <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                    <th *ngIf="hasCustomized">Adjusted Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Size</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.size['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Value</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.value['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Momentum</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.momentum['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.volatility['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">High Yield</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.high_yield['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Quality</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.quality['inception'] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Factor Intensity</th>
                    <td style="color: grey" *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td style="color: grey" *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td style="color: grey" *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Exposure table -->

                <!-- Absolute table -->
                <table *ngIf="selectedAnalyticsTab=='absolute' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="35%"></th>
                    <th *ngIf="hasOriginal">Original Portfolio</th>
                    <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                    <th *ngIf="hasCustomized">Adjusted Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Returns</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.returns.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                    <td style="font-weight: bolder" *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.volatility.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sharpe ratio</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.sharpe_ratio.inception | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Max Drawdown</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.maximum_drawdown.inception | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Absolute table -->

                <!-- Relative table -->
                <table *ngIf="selectedAnalyticsTab=='relative' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="35%"></th>
                    <th *ngIf="hasOriginal">Original Portfolio</th>
                    <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                    <th *ngIf="hasCustomized">Adjusted Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Excess Returns</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.excess_returns.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tracking Error</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.tracking_error.inception | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Information ratio</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.information_ratio.inception | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Max Relative Drawdown</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.performanceRiskAnalysis.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Relative table -->

                <!-- Diversification table -->
                <table *ngIf="selectedAnalyticsTab=='rating' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="35%"></th>
                    <th *ngIf="hasOriginal">Original Portfolio</th>
                    <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                    <th *ngIf="hasCustomized">Adjusted Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Factor Intensity</th>
                    <td style="color: grey" *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td style="color: grey" *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                    <td style="color: grey" *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.exposure.factor_intensity['inception'] | percent:'.0' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Deconcentration</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_deconcentration_quality_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Effective Number of Factors</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factors | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Diversification</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.factorAnalysis.diversification.factor_diversification_quality_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Effective Number of Risks</th>
                    <td *ngIf="hasOriginal">{{ currentOriginal.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                    <td *ngIf="hasDefault">{{ defaultStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                    <td *ngIf="hasCustomized">{{ customizedStrategy.factorAnalysis.diversification.effective_nb_of_factor_bets | number:'1.2-2' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Diversification table -->

                <!-- Robustness table -->
                <table *ngIf="selectedAnalyticsTab=='robustness' && (hasOriginal || hasDefault || hasCustomized)" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="35%"></th>
                    <th *ngIf="hasOriginal">Original Portfolio</th>
                    <th *ngIf="hasDefault">{{ strategyParameters.strategy_type.name }}</th>
                    <th *ngIf="hasCustomized">Adjusted Target</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Performance</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.conditional_performance.conditional_performance_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Risk</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.worst_rolling_risk_statistics.worst_rolling_risk_statistics_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Outperformance</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.outperformance_probability.outperformance_probability_rating"></app-rating-span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Global Rating</th>
                    <td *ngIf="hasOriginal">
                      <app-rating-span [rating]="currentOriginal.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasDefault">
                      <app-rating-span [rating]="defaultStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                    <td *ngIf="hasCustomized">
                      <app-rating-span [rating]="customizedStrategy.robustnessAnalysis.global_robustness_rating"></app-rating-span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- Robustness table -->

                <div *ngIf="currentCluster" class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                  </em>
                </div>
              </div>
              <!-- Adjusted Strategy -->

            </div>
            <div class=" card-footer">
              <div class="text-center">
                <app-button (click)="onImplement()" [disabled]="disableActions">Implement the target</app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Implement the Target Section-->
